import * as React from "react";
import type { SVGProps } from "react";
const SvgLike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path d="M6.25 2.917A4.598 4.598 0 0 0 1.667 7.5c0 1.413.845 2.683 1.928 3.956 1.084 1.273 2.472 2.555 3.818 3.813.641.599 1.99 1.98 1.99 1.98a.833.833 0 0 0 1.194 0s1.349-1.381 1.99-1.98c1.346-1.258 2.734-2.54 3.818-3.813 1.083-1.273 1.928-2.543 1.928-3.956a4.598 4.598 0 0 0-4.583-4.583c-1.382 0-2.69.63-3.75 1.917-1.06-1.288-2.368-1.917-3.75-1.917Zm0 1.666c1.15 0 1.953.357 2.87 1.807l.176.28a.833.833 0 0 0 1.408 0l.176-.28c.917-1.45 1.72-1.807 2.87-1.807A2.91 2.91 0 0 1 16.667 7.5c0 .67-.548 1.72-1.532 2.876-.983 1.156-2.336 2.414-3.686 3.675-.509.476-1.017 1.001-1.449 1.44-.432-.439-.94-.964-1.45-1.44-1.349-1.261-2.702-2.52-3.685-3.675C3.88 9.22 3.333 8.17 3.333 7.5A2.91 2.91 0 0 1 6.25 4.583Z" />
  </svg>
);
export default SvgLike;
